import React, {useState} from 'react';

const Phone = ({onChange, onBlur, defaultValue}) => {
  const [value, setValue] = useState(defaultValue || '+7');

  return (
    <input
      type="text"
      className="form-control"
      onBlur={() => {
        if (onBlur) {
          onBlur(value);
        }
      }}
      value={value}
      onChange={e => {
        const regex = /(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/;
        const x = e.target.value.replace(/\D/g, '').match(regex);

        if (!x[1]) {
          setValue('+7');
          return;
        }

        if (!x[2]) {
          setValue(`+${x[1]}`);
          return;
        }

        const val =
          `+${x[1]} (${x[2]}` +
          (x[3] ? `) ${x[3]}` : '') +
          (x[4] ? `-${x[4]}` : '') +
          (x[5] ? `-${x[5]}` : '') +
          (x[6] ? `-${x[6]}` : '');

        setValue(val);
        if (onChange) {
          onChange(val);
        }
      }}
    />
  );
};

export default Phone;
